import API from "../api";
import {API_GET_OR_CREATE_TEMPLATE, API_UPDATE_TEMPLATE} from "../constants/api";

async function getTemplates(params = {}) {
  try {
    const response = await API.get(
      API_GET_OR_CREATE_TEMPLATE,
      {params: params}
    );
    const responseData = response.data;
    if (responseData.success === true) {
      return responseData.data.templates;
    }
    return Promise.reject("Can not get templates");
  } catch (e) {
    throw e.response;
  }
}

const createTemplate = async (formData) => {
  try {
    const headers = {
      'Content-Type': 'application/json; charset=utf-8'
    }
    const response = await API.post(
      API_GET_OR_CREATE_TEMPLATE,
      formData,
      {headers}
    );
    return response.data;
  } catch (e) {
    throw e;
  }
};

const updateTemplate = async (updateData) => {
  try {
    const headers = {
      'Content-Type': 'application/json; charset=utf-8'
    }
    const payload = {
      templates: updateData['templates'],
      delete_template_ids: updateData['delete_template_ids']
    }
    const response = await API.post(
      API_UPDATE_TEMPLATE,
      JSON.stringify(payload), {headers}
    );
    return response.data;
  } catch (e) {
    throw e;
  }
};

export {
  getTemplates,
  createTemplate,
  updateTemplate,
}